import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import getErrorResponse from './getErrorResponse';
import parseErrors from './parseErrors';

/**
 * Builds a user-facing message that always carries a technical tag
 * (HTTP status or network code) so a support screenshot identifies the
 * failure class without needing devtools. Returns '' only for backend
 * codes that parseErrors deliberately silences.
 */
const describeRequestError = (error: FetchBaseQueryError | SerializedError | undefined): string => {
  if (!error) {
    return 'Ocurrió un error desconocido. (código: E-DESCONOCIDO)';
  }
  if ('status' in error) {
    if (error.status === 'FETCH_ERROR') {
      return 'No pudimos conectar con el servidor. Revisá tu conexión a internet y, si usás un bloqueador de anuncios o antivirus, probá desactivarlo. (código: E-RED)';
    }
    if (error.status === 'TIMEOUT_ERROR') {
      return 'El servidor tardó demasiado en responder. Probá de nuevo en unos minutos. (código: E-TIMEOUT)';
    }
    if (error.status === 'PARSING_ERROR') {
      return `El servidor respondió de forma inesperada. (código: E-HTTP-${error.originalStatus})`;
    }
    if (error.status === 'CUSTOM_ERROR') {
      return `Ocurrió un error: ${error.error} (código: E-CUSTOM)`;
    }
    const data = getErrorResponse(error);
    if (!data || typeof data !== 'object') {
      return `Error del servidor. (código: E-HTTP-${error.status})`;
    }
    const parsed = parseErrors(data);
    if (parsed === '') {
      return '';
    }
    return parsed || `Error del servidor. (código: E-HTTP-${error.status})`;
  }
  return `Ocurrió un error en la aplicación: ${error.message ?? 'sin detalle'} (código: E-APP)`;
};

export default describeRequestError;
